import React, { FC, ReactElement } from 'react'
import styled from 'styled-components'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/comment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'

const Comment: FC<{
  darkModeOn?: string
  avatarSrc: any
  name: string
  byLine: string
  children: JSX.Element
}> = ({ darkModeOn, avatarSrc, name, byLine, children }): ReactElement => {
  return (
    <CommentContainer>
      <div className='ui comments'>
        <div className='comment'>
          <div className='avatar'>
            <img className='ui circular image' src={avatarSrc} />
          </div>
          <div className='content'>
            <div className='author'>Andreas Fischer</div>
            <div className='metadata'>Meteo Schweiz</div>
            <div className='text'>{children}</div>
          </div>
        </div>
      </div>
    </CommentContainer>
  )
}
const CommentContainer = styled.div`
  @media screen and (min-width: 600px) {
    background-color: var(--box-color);
  }
  .comments {
    padding: 1em;
    font-size: 1.6em !important;
    .text,
    .author {
      color: var(--text-color) !important;
      text-align: left;
    }
    .text div {
      font-family: var(--font-serif);
      line-height: 1.6em;
    }
    .comment .metadata {
      color: var(--box-meta);
      margin-left: 0;
      @media screen and (max-width: 599px) {
        color: var(--gray-3);
      }
    }

    @media screen and (max-width: 599px) {
      padding: 0;
      .comment .author {
        display: block;
        margin-left: 0.6em !important;
      }
      .comment > .avatar {
        margin-right: 0.6em;
      }
      .comment > .avatar ~ .content {
        margin-left: 0;
      }

      .comment > .content .author {
        padding-top: 0.4em;
      }
      .comment .metadata {
        margin-bottom: 0.4em;
      }
      .comment > .avatar ~ .text {
        clear: both;
      }
    }
  }
`

export default Comment
